import { getScreensByType } from '@/api/screen-service-api'
import { type ScreenServiceGetByTypeRequest } from 'mnvm-mypage-app-ts-if/dist/apis/ScreenServiceApi'
import { memo, useEffect, useState } from 'react'
import {
  type V1ScreenType,
  type V1Component,
  type V1Screen
} from 'mnvm-mypage-app-ts-if'
import { buildComponent } from '../Component/BaseComponentBuilder'
import { Loading } from '@/components/base/Loading/Loading'

interface Props {
  request?: ScreenServiceGetByTypeRequest
  screenType?: V1ScreenType
  screen?: V1Screen
  componentBuilder?: (
    component: V1Component,
    refetchScreen?: () => Promise<void>
  ) => JSX.Element
}

const ScreenByType = (props: Props): JSX.Element => {
  const [components, setComponents] = useState<V1Component[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { request, screenType, componentBuilder } = props

  useEffect(() => {
    if (props.screen !== undefined) {
      setComponents(props.screen?.components ?? [])
    }
    void onLoadData()
    return () => {}
  }, [])

  const onLoadData = async (): Promise<void> => {
    setIsLoading(true)
    if (request !== undefined) {
      const res = await getScreensByType(request)
      setComponents(res?.screen?.components ?? [])
      setIsLoading(false)
      return
    }

    if (screenType !== undefined) {
      const res = await getScreensByType({ screenType })
      setComponents(res?.screen?.components ?? [])
      setIsLoading(false)
    }
    setIsLoading(false)
  }

  return isLoading ? (
    <Loading />
  ) : (
    <>
      {components.map((e) =>
        componentBuilder !== undefined
          ? componentBuilder(e, onLoadData)
          : buildComponent(e)
      )}
    </>
  )
}

export default memo(ScreenByType)
